
import { gettersInstance } from "@/lib/util";
import LicenseDescription from "@/components/PayWall/LicenseDescription.vue";
import { apiMediaURL } from "@/lib/api";
import { Component, MixedVue, mixins } from "@/vue";
import { ComputedLicencePlan } from "@/lib/types/misc/ComputedLicencePlan";
import { LicenseChooseRequest } from "@/lib/types/actions/LicenseChooseRequest";
import { Prop } from "vue-property-decorator";
import { LegalTerm } from "@/lib/types/LegalTerm";

@Component({
  name: "SecondStep",
  components: { LicenseDescription },
})
export default class SecondStep extends mixins(MixedVue, gettersInstance(["user"])) {
  @Prop({ type: Object, required: false, default: null })
  value: ComputedLicencePlan;

  @Prop({ type: Object, required: false, default: null })
  latestMarketingTerms: LegalTerm;

  tosAgreement = false;
  marketingAgreement = false;

  get marketingUrl() {
    return this.latestMarketingTerms && apiMediaURL(this.latestMarketingTerms.file_url);
  }

  resetSelection() {
    this.$emit("input", null);
  }

  formatDate(d: Date) {
    return d.toLocaleDateString(this.$language.current, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }

  confirmChoice(method: LicenseChooseRequest["license"]["method"]) {
    const result: LicenseChooseRequest = {
      choice: this.value.choice,
      offer: this.value.offer,
      license: { tos: this.tosAgreement, method },
      marketing: this.marketingAgreement,
    };
    this.$emit("confirm", result);
  }
}
